import React from 'react';
import LeadComments from '@/components/Lead/LeadComments';
import { LeadDetailsModel } from '@/typings/models/Lead';

export interface CommentsDrawerProps {
  leadId: string;
  leadDetails: LeadDetailsModel;
  onRefresh?: () => void;
  payload?: { mode?: string; [key: string]: any };
}

/**
 * Comments drawer — the card-based comment timeline (same design as the
 * activity log) with a composer. Opening in "create" mode focuses the composer.
 */
const CommentsDrawer: React.FC<CommentsDrawerProps> = ({
  leadDetails,
  leadId,
  onRefresh,
  payload,
}) => {
  return (
    <LeadComments
      leadId={leadId}
      leadDetails={leadDetails}
      autoFocus={payload?.mode === 'create'}
      onPosted={onRefresh}
    />
  );
};

export default CommentsDrawer;
